"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchConvertedEntries = exports.fetchFetchedEntries = void 0;
const feed_factory_helpers_1 = require("@feed-factory/feed-factory.helpers");
const fetchFetchedEntries = (feedId, page, searchString) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield feed_factory_helpers_1.feedFactoryAxios.get(`/fetchedentries?feedID=${feedId}&page=${page}&search=${searchString}`);
    return res.data;
});
exports.fetchFetchedEntries = fetchFetchedEntries;
const fetchConvertedEntries = (feedId, page, searchString) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield feed_factory_helpers_1.feedFactoryAxios.get(`/convertedentries?feedID=${feedId}&page=${page}&search=${searchString}`);
    return res.data;
});
exports.fetchConvertedEntries = fetchConvertedEntries;
//# sourceMappingURL=fetchFeedEntries.js.map